// DS: i3.8
import React from 'react';
import IconWrap from '../../IconWrap';
const Download = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.913 20a1 1 0 110 2h-10a1 1 0 010-2h10zm-1-19a1 1 0 01.994.883l.006.117v6h3.414a1 1 0 01.76 1.65l-.088.09-8.413 7.648a1 1 0 01-1.246.08l-.1-.08L2.828 9.74a1 1 0 01.556-1.733L3.5 8h3.413V2a1 1 0 01.884-.993L7.913 1h8zm-1 2h-6v7H6.086l5.827 5.297L17.74 10h-2.826V3z",
        fillRule: "evenodd"
    })));
};
Download.displayName = 'Download';
export default Download;

//# sourceMappingURL=Download.js.map